var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-messages"},_vm._l((_vm.messages),function(msg,index){return _c(_vm.messageStyle,{key:index + '_' + msg.time,tag:"div",attrs:{"message":msg},on:{"pasteText":function($event){return _vm.$emit('pasteText', $event)}}})}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }